<div class="viewport-height loading">
  <dcp-loading-indicator></dcp-loading-indicator>
  <p class="udex-mt-12 navigation__regular--xl">{{ loadingText }}</p>
</div>
